<template>
  <div class="h-screen flex flex-col w-0 flex-1 overflow-hidden">
    <main
      class="flex-1 relative z-0 overflow-y-auto focus:outline-none"
      tabindex="0"
    >
      <div class="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
        <button
          @click="toggleMobileSidebar"
          class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150"
          aria-label="Open sidebar"
        >
          <icon set="outline" name="menu" class=" h-6 w-6" />
        </button>
      </div>
      <router-view />
    </main>
  </div>
</template>

<script>
export default {
  name: "Main",
  methods: {
    toggleMobileSidebar() {
      this.$store.commit("toggleMobileSidebar");
    }
  }
};
</script>

<style scoped></style>
